import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { BusinessPunchCardListPage } from '../business-punch-card-list/business-punch-card-list';
import { BusinessUserPunchCardListPage } from '../business-user-punch-card-list/business-user-punch-card-list';

/**
 * Generated class for the BusinessPunchCardMainPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-business-punch-card-main',
  templateUrl: 'business-punch-card-main.html',
})
export class BusinessPunchCardMainPage {

  punchCards = BusinessPunchCardListPage;
  search = BusinessUserPunchCardListPage;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessPunchCardMainPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-punch-card-main/business-punch-card-main.ts